<template>
  <div class="mainInput">
    <div v-if="title" class="labelStyle" :style="title.length > 12 ? { whiteSpace: 'none' } : { whiteSpace: 'nowrap' }">{{ title }}</div>
    <div v-click-outside="closeItems" class="main-div">
      <ul class="checkbox-selected-main">
        <li class="checkbox-selected b-form-tag d-inline-flex align-items-center mw-100" v-for="(item, index) in checkBoxSelected" :key="item.key">
          <i @click="removeItem(item, index)" class="fa fa-times ms-2"></i>
          <div style="color: #556be6">{{ item.value }}</div>
        </li>
        <li class="d-flex align-items-center w-100">
          <input
            :id="comboBoxID"
            :type="type"
            autocomplete="off"
            :class="showError ? `errorStyle` : ``"
            :style="required ? 'border-right: 5px solid #fe5e61;' : inputStyle"
            :required="required"
            v-model="myValue"
            @keyup="searchItem"
            :maxlength="maxlength"
            @keydown.self.enter.prevent="selectItemWithEnter(selectedIndex)"
            @keydown.40.exact="selectNext"
            @keydown.38.exact="selectPrev"
            :disabled="disabled"
            :placeholder="checkBoxSelected.length > 0 ? '' : placeholder"
            class="input__style"
            @focus="openItems"
          />
          <i class="chevron-combo" :class="{ down: isToggled, up: !isToggled }"> </i>
        </li>
      </ul>
      <div v-if="showError" class="errorClass">{{ errortext }}</div>
      <div @scroll="onScroll" v-if="ShowItems" class="itemStyle" ref="scrollCombo">
        <div class="p-2" v-if="searchedData.length > 0">
          <b-form-checkbox v-for="option in searchedData" v-model="checkboxVal" @change="selected(option)" :key="option.key" :value="option.key" :name="option.value">
            {{ option.value }}
          </b-form-checkbox>
        </div>
        <div class="mt-2" v-else>دیتایی موجود نمی باشد.</div>
        <div v-if="hasButton" class="buttonClass" style="border-top: 1px solid #ced4da" @click="buttonAction">
          <p class="p-2 m-0 p">{{ buttonText }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { searchComboMixins } from '../../../../utils/mixins'
export default {
  name: 'comboBox-input',
  data() {
    return {
      checkboxVal: [],
      checkBoxSelected: [],
      ShowItems: false,
      isToggled: false,
      myValue: '',
      selectedIndex: -1,
    }
  },
  mixins: [searchComboMixins],
  props: {
    mainClass: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    inputClassName: {
      type: String,
      default: '',
    },
    inputStyle: {
      type: String,
      default: '',
    },
    labelStyle: {
      type: String,
      default: 'right:5%;',
    },
    showError: {
      type: Boolean,
      default: false,
    },
    errortext: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    selectedValue: {
      type: Array,
      default: null,
    },
    maxlength: {
      type: Number,
    },
    componentData: {
      type: Array,
      default: null,
    },
    searchedData: {
      type: Array,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasButton: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '',
    },
    pagination: {
      type: Boolean,
      default: false,
    },
    invoice: {
      type: Boolean,
      default: false,
    },
    isColor: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    checkboxVal(val) {
      this.$emit('input', val)
    },
    selectedValue(val) {
      this.checkBoxSelected = val
    },
    searchedData() {
      this.selectedIndex = -1
    },
    ShowItems(val) {
      if (val == true) {
        this.$emit('itemsOpened', true)
      } else if (val == false) {
        this.$emit('itemsOpened', false)
      }
    },
  },
  methods: {
    selected(select) {
      var removeByAttr = function (arr, attr, value) {
        var i = arr.length
        while (i--) {
          if (arr[i] && arr[i].hasOwnProperty(attr) && arguments.length > 2 && arr[i][attr] === value) {
            arr.splice(i, 1)
          }
        }
        return arr
      }
      let checkData = this.checkBoxSelected.find((d) => d.key == select.key)
      if (!checkData) {
        this.checkBoxSelected.push(select)
      } else {
        this.checkBoxSelected = removeByAttr(this.checkBoxSelected, 'key', select.key)
      }
    },
    removeItem(item, index) {
      var removeByAttr = function (arr, attr, value) {
        var i = arr.length
        while (i--) {
          if (arr[i] && arr[i].hasOwnProperty(attr) && arguments.length > 2 && arr[i][attr] === value) {
            arr.splice(i, 1)
          }
        }
        return arr
      }
      this.checkBoxSelected = removeByAttr(this.checkBoxSelected, 'key', item.key)
      this.checkboxVal.splice(index, 1)
    },
    selectNext() {
      this.selectedIndex++
    },
    selectPrev() {
      this.selectedIndex--
    },
    selectItemWithEnter(enterIndex) {
      this.selectItem(this.searchedData[enterIndex])
      document.getElementById(this.comboBoxID).blur()
    },
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        if (this.pagination) {
          this.$emit('loadMoreData')
        }
      }
    },
    openItems() {
      this.ShowItems = true
      this.isToggled = true
    },
    closeItems() {
      this.ShowItems = false
      this.isToggled = false
    },
    searchItem(searchedValue) {
      var searchValue = searchedValue.key
      if (searchValue == 'ArrowLeft' || searchValue == 'ArrowRight' || searchValue == 'ArrowUp' || searchValue == 'ArrowDown') {
        return
      } else {
        this.$refs.scrollCombo.scrollTop = 0
        this.$emit('searchedItem', this.myValue)
      }
    },
    selectItem(data) {
      this.myValue = data.value
      this.$emit('selectedItem', data)
    },
    buttonAction() {
      this.$emit('buttonAction')
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value
      },
    },
    comboBoxID() {
      return Math.random()
    },
  },
  mounted() {
    if (this.invoice) {
      this.myValue = this.selectedCustomer.value
    }
  },
  created() {
    if (this.selectedValue) {
      this.checkBoxSelected = this.selectedValue
    }
  },
}
</script>

<style scoped lang="scss">
.errorStyle {
  line-height: 17px;
  width: 100%;
  color: #74788d;
  background: #ffffff;
  border: 1px solid #fe5e61;
  padding: 6px 10px;
  box-sizing: border-box;
}
.color__preview {
  background: white;
  width: 12px;
  height: 12px;
  border-radius: 1px;
  margin-left: 10px;
}
.errorClass {
  font-size: 10px;
  color: #fe5e61;
}
.buttonClass {
  position: sticky;
  bottom: 0;
  background: white;
  border-top: 1px solid #ced4da;
  cursor: pointer;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0px;
  transition: 0.2s ease-in-out;
}
.buttonClass:hover {
  background-color: #f2f4f7;
}
.mainInput {
  display: flex;
  align-items: center;
}
.labelStyle {
  min-width: 90px;
  max-width: 90px;
  margin-left: 10px;
  display: table;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: #444444;
  justify-content: start;
  align-items: center;
}

.chevron-combo {
  position: absolute;
  top: 10px;
  left: 10px;
  border: solid #555555;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
}
.down {
  transform: rotate(-135deg);
}
.up {
  transform: rotate(45deg);
}
.mainClass {
  width: 100%;
  position: relative;
}
.loading-container {
  border-radius: 8px;
  display: flex;
  margin-bottom: 20px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
::-webkit-scrollbar {
  width: 5px;
  display: none;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #556ee6;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
.checkbox-selected {
  .fa-times {
    color: #556ee6;
    font-size: 10px;
    cursor: pointer;
  }
}
.checkbox-selected-main {
  padding: 2px 0px 4px 0px;
  width: 100%;
  display: flex;
}
.checkbox-selected {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  background: #dde3ff;
  border-radius: 3px;
  padding: 3px;
  margin: 0 3px;
}
.main-div {
  position: relative;
  width: 100%;
  height: 32px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  background: #ffffff;
}
ul {
  list-style-type: none;
  margin-bottom: 0;
}
input {
  padding: 4px 10px 0 0 !important;
  -webkit-appearance: none;
  appearance: none;
  border: none;
  outline: none;
  text-align: right;
  width: 95%;
}
input::placeholder {
  padding: 0 7px;
}
input:disabled {
  width: 100%;
  color: #c6cbd0;
  background: #ffffff;
  border: 1px solid #ced4da;
  padding: 6px 10px;
  box-sizing: border-box;
}
input:disabled::placeholder {
  color: #c6cbd0;
}
input:disabled + i {
  position: absolute;
  top: 10px;
  left: 10px;
  border: solid #c6cbd0;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
}
.custom-input {
  width: 100%;
  position: relative;
  font-size: 14px;
  font-weight: 400;
  font-family: IRANSans;
}
.errText {
  color: #eb4137;
  font-size: 12px;
  margin-right: 10px;
  width: 100%;
  text-align: right;
}
.submitStyle2 {
  padding: 7px 23px;
  align-items: center;
  color: #fff !important;
  margin: 10px;
  width: 95%;
  font-size: 15px;
  font-weight: 500;
  box-shadow: 0 2px 7px 0 rgb(214, 214, 214);
  background-color: #2585ff;
}
.blueIR {
  color: #4285f2;
}
.modalData {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.itemRow {
  display: flex;
  min-height: 40px;
  align-items: center;
  color: rgba(0, 0, 0, 0.87) !important;
  outline: none;
  cursor: pointer;
  font-size: 13px;
  padding: 8px 16px;
}
.itemRow:hover {
  background: #ececec;
}
.itemStyle {
  width: 100%;
  position: relative;
  z-index: 2;
  max-height: 200px;
  overflow-x: hidden;
  overflow-y: scroll;
  box-shadow: 0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%);
  background: white;
}
input:focus {
  outline: none;
}
input:focus::placeholder {
  color: transparent;
}
input::placeholder {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  color: #74788d;
}
</style>
